import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

const WORK_PERIOD_FORM_MODAL = 'WorkPeriodModal'

const WorkPeriodFormModal = Loadable(() => import('./WorkPeriodForm'))

export const createWorkPeriodNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'period',
  text: translateFn('cmd_acc_work_period'),
  identity: WORK_PERIOD_FORM_MODAL,
  component: WorkPeriodFormModal,
}))
